import i18n from 'i18n';

const GET_STORM_RATES_URL = '/backend/service/storm-rate';
const CREATE_STORM_RATE_URL = '/backend/service/storm-rate/create-storm-rates';

const DUPLICATE_LABEL = i18n.t('duplicate', { ns: 'rates' });
const PUBLISH_LABEL = i18n.t('publish', { ns: 'rates' });
const DEPUBLISH_LABEL = i18n.t('depublish', { ns: 'rates' });

const DEPUBLISH_FAILURE_TOAST = i18n.t('depublishFailure', {
  ns: 'rates',
});
const DEPUBLISH_SUCCESS_TOAST = i18n.t('depublishSuccess', {
  ns: 'rates',
});

const PUBLICATE_SUCCESS_TOAST = i18n.t('publicationSuccess', {
  ns: 'rates',
});
const PUBLICATE_FAILURE_TOAST = i18n.t('publicationFailure', {
  ns: 'rates',
});
const DUPLICATE_SUCCESS_TOAST = i18n.t('duplicateSuccess', {
  ns: 'rates',
});
const DUPLICATE_ERROR_TOAST = i18n.t('duplicateFailure', { ns: 'rates' });

export {
  GET_STORM_RATES_URL,
  DUPLICATE_LABEL,
  PUBLISH_LABEL,
  PUBLICATE_SUCCESS_TOAST,
  PUBLICATE_FAILURE_TOAST,
  CREATE_STORM_RATE_URL,
  DUPLICATE_ERROR_TOAST,
  DUPLICATE_SUCCESS_TOAST,
  DEPUBLISH_LABEL,
  DEPUBLISH_FAILURE_TOAST,
  DEPUBLISH_SUCCESS_TOAST,
};
